import { useEffect,useState } from "react";
import { Cookies } from "react-cookie-consent";
import { useSelector ,useDispatch} from "react-redux";
import {setTheme} from "./LoginModalSlice" 

function DarkModeIcon() {
  const dispatch = useDispatch();

  const setCookie = (cookieValue) => {
    Cookies.set("gfg_theme", cookieValue, {
      expires: 800,
      path: "/",
    domain: ".geeksforgeeks.org",
    });
  };

  const { theme } = useSelector((state) => state);
  const [showRedDot, setShowRedDot] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("gfgThemeRedDotSelector")) {
      setShowRedDot(true);
    }
  }, []);

  useEffect(() => {
    const value = Cookies.get("gfg_theme");

    if (value === "gfgThemeDark") {
      dispatch(setTheme("dark"));
    } else {
      dispatch(setTheme("light"));
    }

    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = ''; // Chrome compatibility
      dispatch(setTheme("light"));
    };
  
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [dispatch]);


  return (
    <>
    <div
      onClick={() => {
        dispatch(setTheme(theme === "dark" ? "light" : "dark"));
        setCookie(theme === "dark" ? "gfgThemeLight" : "gfgThemeDark");
        localStorage.setItem("gfgThemeRedDotSelector",1);
        setShowRedDot(false);
      }}
      className={`dark_mode__container ${
            theme === "dark" ? "dark_mode_warp" : "light_mode_warp"
      }`}
    >
        {theme==="light" ? (<img
          src="https://media.geeksforgeeks.org/img-practice/prod/apis/1/Web/Header/Path 4447 (1)_1687330352.svg"
          width={20}
          height={20}
          alt=""
        />):
        (<img
          src="https://media.geeksforgeeks.org/img-practice/prod/problems/2/Web/Header/Group%204553_1687329661.svg"
          width={25}
          height={25}
          alt=""
        />)}
        <div className={`${showRedDot ? "red_dot" : ""}`} />
    </div>
    <span className="darkModeTooltipText">{theme==="light"? "Switch To Dark Mode" :"Switch To Light Mode"}</span>
    </>
  );
}
export default DarkModeIcon;
